module.exports = __webpack_public_path__ + "img/nt7-00a-82-1.prt.1f59c595.jpg";